import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

import { AlertService } from 'src/app/services/alert.service';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-search-users',
  templateUrl: './search-users.component.html',
  styleUrls: ['./search-users.component.scss'],
})
export class SearchUsersComponent implements OnInit {

  user;
  idUsuario;
  loading = false;
  currentPage = 1;
  usuarios: any[] = [];
  scrolling: boolean = false;
  infScrollDisabled = false;

  constructor(
    private modalController: ModalController,
    private alertService: AlertService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
  ) {
    this.obtenerUsuario(null, {}, false);
  }

  async ionViewWillEnter() {
    // obtener datos del usuario desde el servicio y asignar al formulario
    this.user = await this.authService.getUser();
    if (!this.loading) this.obtenerUsuario(null, {}, false);
  }

  ngOnInit() {
    if (!this.loading) this.obtenerUsuario(null, {}, false);
  }

  ionInfinite(event) {
    this.currentPage++;
    this.scrolling = true;
    this.obtenerUsuario(event);
  }

  async obtenerUsuario(event?, query = {}, push = true) {
    this.loading = true;

    query['page'] = this.currentPage;

    const response: any = await this.userService.list(query);
    if (response.success) {
      if (push) this.usuarios.push(...response.data);
      else this.usuarios = response.data;

      if (response.data.length == 0) this.infScrollDisabled = true;
    }

    if (event) {
      try { event.target.complete(); }
      catch(e) {}
    }

    this.loading = false;
  }

  buscar(event) {
    this.currentPage = 1;
    let value = event.detail.value;
    if (value.length > 3) {
      let query = { name: value, email: value };
      this.obtenerUsuario(null, query);
    } else if (value == '') this.obtenerUsuario();
  }

  selectUser(user) {
    this.modalController.dismiss(user);
  }

  refresh(event) {
    this.usuarios = [];
    this.currentPage = 1;
    this.infScrollDisabled = false;
    this.obtenerUsuario(event);
  }

  close() {
    this.modalController.dismiss();
  }
}